import {
  authenticationActions
} from './store/actions/authentication';

/**
 * Enable in the browser console: localStorage.setItem('AUTH_DEBUG', '1') — then reload.
 * @returns {boolean} Whether client-side auth timing logs should print
 */
const isAuthClientTrace = () => {
  try {
    return typeof window !== 'undefined' &&
      window.localStorage &&
      window.localStorage.getItem('AUTH_DEBUG') === '1';
  } catch (e) {
    return false;
  }
};

const authClientLog = (label, payload) => {
  if (!isAuthClientTrace()) {
    return;
  }
  console.log('[auth:client]', label, payload || '');
};

const isAuthError = (error) => {
  const name = error && error.name ? String(error.name) : '';
  const message = error && error.message ? String(error.message) : '';
  return (
    name === 'NotAuthenticated' ||
    name === 'Forbidden' ||
    message.toLowerCase().indexOf('no auth token') !== -1 ||
    message.toLowerCase().indexOf('not authenticated') !== -1 ||
    message.toLowerCase().indexOf('jwt') !== -1
  );
};

const isPublicPath = (pathname) => {
  return (
    pathname === '/' ||
    pathname === '/sign-in' ||
    pathname.indexOf('/sign-in/') === 0 ||
    pathname.indexOf('/payment/') === 0 ||
    pathname.indexOf('/print/username/') === 0
  );
};

const clearAuthAndRedirectToSignIn = () => {
  try {
    window.localStorage.removeItem('feathers-jwt');
    window.localStorage.removeItem('jwt');
    window.localStorage.removeItem('token');
    window.sessionStorage.removeItem('feathers-jwt');
  } catch (e) {
    // ignore storage access issues
  }

  if (!isPublicPath(window.location.pathname)) {
    window.location.assign('/sign-in');
  }
};
const authenticate = (options, client, dispatch) => {
  return new Promise((resolve, reject) => {
    const now =
      typeof performance !== 'undefined' && typeof performance.now === 'function'
        ? () => performance.now()
        : () => Date.now();
    const flowStarted = now();

    dispatch(authenticationActions.userAuthenticationAttempt());
    authClientLog('authenticate flow start', {
      hasExplicitOptions: options !== undefined && options !== null,
      strategy: options && options.strategy
    });

    client
      .authenticate(options)
      .then(response => {
        authClientLog('client.authenticate resolved', {
          ms: Number((now() - flowStarted).toFixed(1)),
          hasAccessToken: !!(response && response.accessToken)
        });
        const jwtStarted = now();
        return client.passport.verifyJWT(response.accessToken).then((payload) => {
          authClientLog('verifyJWT done', {
            ms: Number((now() - jwtStarted).toFixed(1)),
            userId: payload && payload.userId
          });
          return payload;
        });
      })
      .then(payload => {
        const getStarted = now();
        return client.service('api/users').get(payload.userId).then((user) => {
          authClientLog('api/users.get done', {
            ms: Number((now() - getStarted).toFixed(1)),
            userId: payload && payload.userId
          });
          return user;
        });
      })
      .then(user => {
        authClientLog('authenticate flow success', {
          totalMs: Number((now() - flowStarted).toFixed(1)),
          userId: user && user.id
        });
        dispatch(authenticationActions.userAuthenticationSuccess(null, user));

        client.set('user', user);
        client.set('error', null);

        resolve(user);
      })
      .catch(error => {
        authClientLog('authenticate flow error', {
          name: error && error.name,
          message: error && error.message,
          totalMs: Number((now() - flowStarted).toFixed(1))
        });
        dispatch(authenticationActions.userAuthenticationFailure(error));

        client.set('user', null);
        client.set('error', error);

        if (isAuthError(error)) {
          clearAuthAndRedirectToSignIn();
        }

        reject(error);
      });
  });
};

export default (client, dispatch) => {
  return (options) => authenticate(options, client, dispatch);
};


// WEBPACK FOOTER //
// ./src/authenticate.js